module.exports = __webpack_public_path__ + "static/media/img1.daef1f26.svg";